import styled from "styled-components"

import SVGIcon from "components/presenters/common/SVGIcon"
import CheckBox from "components/presenters/button/CheckBox"

export default function ShippingItem({ shipping, isChecked = false, onDelete, onCheck }) {
  return (
    <ShippingBlock>
      <label htmlFor={`shipping-item-no-${shipping.no}`}>
        <CheckBox id={`shipping-item-no-${shipping.no}`} checked={isChecked} onChange={onCheck} />
      </label>
      <AddressInfoBlock>
        <RoadName>{shipping.address1}</RoadName>
        <DetailInfo>{shipping?.address2}</DetailInfo>
        <DetailInfo>{`${shipping.recipient} ${shipping.phone}`}</DetailInfo>
      </AddressInfoBlock>
      <CLoseIconBlock onClick={() => onDelete(shipping.no)}>
        <SVGIcon name="close" />
      </CLoseIconBlock>
    </ShippingBlock>
  )
}

const ShippingBlock = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
  margin-bottom: calc(100vw * (32 / 375));
  padding-bottom: calc(100vw * (32 / 375));
  border-bottom: 1px solid #efefef;

  &:nth-last-child(3) {
    border-bottom: none;
    padding-bottom: 0;
  }
`

const AddressInfoBlock = styled.div`
  display: flex;
  flex-direction: column;
`

const RoadName = styled.span`
  padding-right: calc(100vw * (16 / 375));
  font-style: normal;
  font-weight: 700;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (16 / 375));
  color: #121212;
  margin-bottom: calc(100vw * (4 / 375));
`

const DetailInfo = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (22 / 375));
  color: #4e4e4e;
`

const CLoseIconBlock = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: calc(100vw * (14 / 375));
  height: calc(100vw * (14 / 375));

  svg {
    color: #7f7f7f;
  }
`
